import { Injectable } from '@angular/core';
import { CustomBasePageMetaResolver } from '@core/feature';
import {
  BreadcrumbMeta,
  CanonicalPageResolver,
  PageBreadcrumbResolver,
  PageDescriptionResolver,
  PageMetaResolver,
  PageRobotsMeta,
  PageRobotsResolver,
  PageTitleResolver,
  PageType,
} from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PromoContentPageMetaResolver
  extends PageMetaResolver
  implements
    PageTitleResolver,
    PageBreadcrumbResolver,
    PageDescriptionResolver,
    PageRobotsResolver,
    CanonicalPageResolver
{
  constructor(private basePageMetaResolver: CustomBasePageMetaResolver) {
    super();
    this.pageType = PageType.CONTENT_PAGE;
    this.pageTemplate = 'SdPromoContentPageTemplate';
  }

  resolveTitle(): Observable<string | undefined> {
    return this.basePageMetaResolver.resolveTitle();
  }

  resolveBreadcrumbs(): Observable<BreadcrumbMeta[]> {
    return this.basePageMetaResolver.resolveBreadcrumbs().pipe(
      map((crumbs) => {
        return [...crumbs.slice(0, 1), { label: 'Акции и спецпредложения', link: '/promo' }, ...crumbs.slice(1)];
      }),
    );
  }

  resolveDescription(): Observable<string | undefined> {
    return this.basePageMetaResolver.resolveDescription();
  }

  resolveRobots(): Observable<PageRobotsMeta[]> {
    return this.basePageMetaResolver.resolveRobots();
  }

  resolveCanonicalUrl(): Observable<string | undefined> {
    return this.basePageMetaResolver.resolveCanonicalUrl();
  }
}
